/**
 * Created by mnaughton on 10/16/2015.
 */

import BaseFieldView from "core/views/Field/BaseFieldView";
import _ from "underscore";
export default BaseFieldView.extend({
  template: _.template(
    '<%if(value){%><a href="<%-url%>" data-value="<%-value%>" target="_blank">Download</a><%} else {%>No file found.<%}%>'
  ),

  serialize: function () {
    var url;

    if (this.value) {
      url = this.options.documentFactory.createDocumentUrl(this.value);
    }

    return {
      value: this.value,
      url: url,
    };
  },

  getControlValue: function () {
    return this.$("a").data("value");
  },

  setControlValue: function () {
    this.render();
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/view/FileView.js
// module id = 481
// module chunks = 1